import PropTypes from 'prop-types';
import React from 'react';
import S from 'styles/form.scss';
import cx from 'classnames';
import styles from 'styles/input.scss';

const SimpleInput = ({ label, text, onChange, className, errors }) => {
  const errorMsg = errors.join(', ');
  const wrapperStyles = errorMsg ? cx(styles.errored, className) : className;
  const textAreaStyles = cx(styles.inputElement, S.inputArea);
  const labelStyles = errorMsg ? cx(S.label, S.errorLabel) : S.label;

  return (
    <div className={wrapperStyles}>
      <h6 className={labelStyles}>{label}</h6>
      <input
        className={textAreaStyles}
        value={text}
        onChange={onChange}
      />

      {errorMsg &&
        <div className={styles.error}><p className={S.errorMsg}>{errorMsg}</p></div>}
    </div>
  );
};

SimpleInput.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.number],
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
  className: PropTypes.string,
};

SimpleInput.defaultProps = {
  label: '',
  text: '',
  errors: [],
};

export default SimpleInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/SimpleInput/index.jsx